import { useDispatch, useSelector } from 'react-redux';
import { scheduleFullMigration } from '../../store/actions/Migration';

import _ from 'lodash';
import dayjs from "dayjs";
import React, { useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import CustomStyleDatePicker from "../date-picker/index";

const SchedulerModal = (props) => {

    const dispatch = useDispatch();
    const [scheduleMigrationTime, setScheduleMigrationTime] = useState('');
    const [scheduleMigrationDate, setScheduleMigrationDate] = useState(dayjs());
    const { migration, newDeltaMigration } = useSelector(st => st['Migration']);

    const migrationType = props.migrationType;
    const isScheduleMigrationModalOpen = props.isScheduleMigrationModalOpen;
    const setIsScheduleMigrationModalOpen = props.setIsScheduleMigrationModalOpen;

    const buildScheduleRequest = () => {
        
        const isDelta = migrationType == 'DELTA';
        const migrationKey = isDelta ? newDeltaMigration['key'] : migration['key'];
        const data = { deltaMigrationId: newDeltaMigration['_id'], key: newDeltaMigration['key']};

        return { 
            key:  migrationKey,
            type: migrationType,
            date: scheduleMigrationDate,
            time: scheduleMigrationTime,
            data: isDelta ? data : undefined
        }
    }

    return (
        <Modal
            centered
            style={{width: '80%'}}
            className='modal-payment'
            isOpen={isScheduleMigrationModalOpen}
            aria-labelledby='contained-modal-title-vcenter'
        >
            <ModalBody>
                <div className='payment-box'>
                    <div className='title-area text-center'> <h5>Schedule migration</h5> </div>
                    <p className='pt-2' style={{ 'fontSize': '17px' }}> Your migration will automatically run at the time you setup below. </p>
                    <br />
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
                        <CustomStyleDatePicker date={scheduleMigrationDate} setDate={setScheduleMigrationDate} disablePastDates={true} />
                        <input 
                            type="time" 
                            value={scheduleMigrationTime} 
                            onChange={(e) => setScheduleMigrationTime(e.target.value)} 
                            step="60"
                            style={{ padding: '5px', fontSize: '16px', width: '120px' }} 
                        />
                    </div>
                    <br />
                    <div className='text-center pt-3'>
                        <button className='mx-5 btn-style-two' onClick={() => setIsScheduleMigrationModalOpen(false)}> Cancel </button>
                        <button 
                            className='btn-style-one' 
                            onClick={() => {
                                dispatch(scheduleFullMigration(buildScheduleRequest()));
                                setIsScheduleMigrationModalOpen(false);
                            }}> Schedule migration </button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default SchedulerModal;